import Vue from 'vue'
import CONF from '@/app.conf.json'
import {Util} from '../commons/util'

// Promise 垫片
require('core-js/fn/promise');

let Service = {

  /**
   * 查询首页推荐导购、店铺
   * @params {String} cityId       城市ID
   * @params {String} longitude    经度
   * @params {String} latitude     纬度
   * @params {[String | Number]} queryType
   *          3: 找门店
   *          4：附近门店
   * @return Promise
   * */
  queryHomeNearStore(opts){

    let assignParams = $.extend(
      {
        cityId: '025',
        districtId: '',
        queryVal: '',
        storeType: '',
        cbdId: '',
        longitude: '',
        latitude: '',
        queryType: 4,
        top: true,
        pageNumber: 1,
        pageSize: 10
      }, opts);
    let url = CONF.API.queryNearStore;

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        params: assignParams,
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body.data);
        } else if (data.body.code === '1') {
          resolve({
            datas: [],
            pageCount: 0,
            isLastPage: 1
          });
        } else if (data.body.code === '0001') {
          reject(new Error(`${url}接口参数错误`));
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },

  /**
   * 查询首页数据
   * @params {String} cityCode       城市ID
   * @return Promise
   * */
  queryActivityChooseNew(cityCode) {

    let url = CONF.API.activityChooseNew,
      jsonpCallback = 'queryActivityChooseNewCallback';

    url = url
      .replace('{{cityCode}}', cityCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body)
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },


  /**
   * 获取身边苏宁wap页 iocn
   * @params {String} cityCode  城市编码
   * @returns {Promise}
   */
  queryHomeIcon(cityCode) {

    let url = CONF.API.queryHomeIcon,
      jsonpCallback = 'queryHomeIconCallback';

    url = url
      .replace('{{cityCode}}', cityCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body)
        }else if (data.body.code === '0005') {
          resolve({data: []});
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },

  /**
   * 获取身边苏宁wap页 横通AD
   * @params {String} cityCode  城市编码
   * @returns {Promise}
   */
  queryHomeAD(cityCode) {

    let url = CONF.API.queryHomeAD,
      jsonpCallback = 'queryHomeADCallback';


    url = url
      .replace('{{cityCode}}', cityCode)
      .replace('{{id}}', '8')
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body)
        } else if (data.body.code === '0005') {
          resolve({data: []});
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  },
  /**
   * 获取身边苏宁wap页 大促活动
   * @params {String} cityCode  城市编码
   * @returns {Promise}
   */
  queryAdvertInfo(cityCode) {

    let url = CONF.API.queryAdvertInfo,
      jsonpCallback = 'queryAdvertInfoCallback';

    url = url
      .replace('{{cityCode}}', cityCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body.data)
        }else if (data.body.code === '0005') {
          resolve({});
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data))
      });
    });
  }
};

export default Service;



// WEBPACK FOOTER //
// ./src/services/Home.js